import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from 'jquery'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import BulkFeedbackComponent from "../../bulk/BulkFeedbackComponent.tsx"
import { Guard, Permissions } from "../../role/Guard.jsx"
import GlobalHelper from "../GlobalHelper.jsx"
import Icon from "../icon/icon.component.jsx"
import LinkSideBarWrapper from '../rich-text/feature-protection-wrappers/linkSideBarWrapper.component'
import Breadcrumbs from './breadcrumbs.component.jsx'
import './embeddednavbar.scss'
import { GetAllowedAdminMenus, GetAllowedMenus } from "./menus.jsx"
import './sidebar.scss'

class EmbeddedNavBar extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            user: AppContext.getUserLoggedIn(),
        }
        this.menuInit = this.menuInit.bind(this)
    }

    componentDidMount() {
        this.menuInit()
    }

    menuInit() {
        if (["xs", "sm"].includes(GlobalHelper.getResponsiveBreakpoint())) {
            $(".menu-text").css('display', 'none')
        }
    }

    render() {
        let adminMenuItems = []
        if (Guard.isAuthorized(Permissions.AdminMenus)) {
            adminMenuItems = GetAllowedAdminMenus()
        }

        const containerClasses = "fixed-top px-3 pt-2 box-shadow bg-embedded-nav-bar border-bottom position-fixed full-height z-index-menu d-block w-100"
        const menus = GetAllowedMenus()

        return [
            <nav key={0} className={containerClasses} style={{ height: '3.2rem' }}>
                <div className="fixed-top d-flex align-content-between justify-content-center flex-wrap ">
                    <Breadcrumbs isHidden={true} history={this.props.history} />
                    <ul className="nav mt-1">
                        {
                            menus.map((m, i) => {
                                return <li className="nav-item embedded" key={i}>
                                    <LinkSideBarWrapper
                                        module={m.module}
                                        to={m.link}
                                        redirectToAccount={true}
                                        className={"menu nav-link embedded active pr-0 pl-3 d-flex flex-nowrap " + m.className}
                                        protectedClassName={"menu nav-link embedded active pr-0 pl-3 d-flex flex-nowrap" + m.className}
                                        premium={false}
                                        protectionRule={m.module === "" ? true : AppContext.accountFeatureIsEnabled(m.module)}
                                    >
                                        {m.icon}
                                        <span className={'menu-text mr-auto ' + m.className}>{m.name}</span>
                                    </LinkSideBarWrapper>
                                </li>
                            })
                        }
                        <li className="nav-item embedded" key='menu-1'>
                            <hr className="menu-separator box-shadow" />
                        </li>
                        {
                            adminMenuItems.map((m, i) => {
                                return <li className="nav-item embedded" key={i}>
                                    <LinkSideBarWrapper
                                        module={m.module}
                                        onClick={(e) => this.hideMenu(e)}
                                        to={m.link}
                                        redirectToAccount={true}
                                        className={"menu nav-link embedded active pr-0 pl-3 d-flex flex-nowrap " + m.className}
                                        protectedClassName={"menu nav-link embedded active pr-0 pl-3 d-flex flex-nowrap " + m.className}
                                        premium={false}
                                        protectionRule={m.module === "" ? true : AppContext.accountFeatureIsEnabled(m.module)}
                                    >
                                        {m.icon}
                                        <span className={'menu-text mr-auto'}>{m.name}</span>
                                    </LinkSideBarWrapper>
                                </li>
                            })
                        }
                        <div className="pr-1 pl-2">
                            <BulkFeedbackComponent isShopify={true} />
                        </div>
                        <li className="nav-item embedded" key={'menu-user'}>
                            <Link to={`/users/edit/${this.state.user.id}`} className={"menu nav-link embedded pr-0 pl-3 d-flex flex-nowrap menu-user"}>
                                <Icon value="user" className={"mr-1"} />
                                <span className={'menu-text mr-auto menu-user'}>
                                    {this.state.user.attributes.firstName.charAt(0).toUpperCase() + this.state.user.attributes.lastName.charAt(0).toUpperCase()}
                                </span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>,
        ]
    }
}

export default EmbeddedNavBar


// WEBPACK FOOTER //
// ./src/common/layout/embeddednavbar.component.jsx